/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useRef, useEffect } from 'react';
import { HotelImageType } from 'data/travel-agency/customer/hotelDetails';
import useLightbox from 'hooks/useLightbox';
import Lightbox from 'components/base/LightBox';
import classNames from 'classnames';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

import '../../App.css'
import 'react-h5-audio-player/lib/styles.css';
import { IThermogram } from 'pages/thermography/model/thermogram.model';
import ThermogramView from './ThermogramView';
interface ThermalAnomalyImagesItemProps {
	item: HotelImageType;
	handleClick: () => void;
	onChange?: () => void;
	isLast: boolean
}

const DetailsGalleryItem = ({
	item,
	handleClick,
	onChange,
	isLast
}: ThermalAnomalyImagesItemProps) => {
	return (

		<div
			className={classNames(item.classNames, 'cursor-pointer')}
			onClick={handleClick}
		>
			<img src={item.img} alt="" className="rounded-2 img-fluid" />
		</div>
	);
};

interface ThermalAnomalyImagesProps {
	images: HotelImageType[];
	className?: string;
	mode: string | null;
	thermogram: IThermogram;
	setThermogram: React.Dispatch<React.SetStateAction<IThermogram>>;
	thermogramRef: IThermogram;
	setThermogramRef: React.Dispatch<React.SetStateAction<IThermogram>>;
	deltaT: number;
	setDeltaT: React.Dispatch<React.SetStateAction<number>>;
}

const ThermalAnomalyImages = ({
	images,
	className,
	mode,
	thermogram,
	setThermogram,
	thermogramRef,
	setThermogramRef,
	deltaT = 0,
	setDeltaT
}: ThermalAnomalyImagesProps) => {
	const fileInputRef = useRef<HTMLInputElement>(null);
	const { t } = useTranslation();
	const tt = (key: string, options?: Record<string, unknown>) => t(key, { ns: "translation", ...options });

	const { lightboxProps } = useLightbox(
		images.map((item: HotelImageType) => item.largeImg)
	);

	useEffect(() => {
		if (thermogram && thermogramRef) {

			setDeltaT(parseFloat(((thermogram?.maxTempRoi ?? 0) - (thermogramRef?.maxTempRoi ?? 0)).toFixed(1)));
		}
	}, [thermogram, thermogramRef]);

	return (
		<>
			<Row className="g-3">
				<Col xl={6}>
					<Card className={className}>
						<Card.Body>
							<ThermogramView
								className={className}
								mode={mode}
								thermogram={thermogram}
								setThermogram={setThermogram}
								title={tt("pages.thermography.thermalAnomalyImages.monitoringThermogram")}

								tempRef={thermogramRef.maxTempRoi ?? undefined}
								deltaT={deltaT}
							/>
						</Card.Body>
					</Card>
				</Col>

				<Col xl={6}>
					<Card className={className}>
						<Card.Body>
							<div className={`position-relative ${className}`}>
								<Row className="flex-fill" style={{ height: '45%', overflowY: 'auto' }}>
									<ThermogramView
										className={className}
										mode={mode}
										thermogram={thermogramRef}
										setThermogram={setThermogramRef}
										title={tt("pages.thermography.thermalAnomalyImages.referenceThermogram")}
										showMetaData={false}
									/>
								</Row>
							</div>
						</Card.Body>

					</Card>
				</Col>
			</Row >
			<div>
				<Lightbox {...lightboxProps} />
			</div>
		</>
	);
};

export default ThermalAnomalyImages;
